import { TBrand, ThemeProvider } from 'telia-front-react';
import React from 'react';
import useStores from '../stores/UseStores';
import { injectModuleSsoCss, injectSsoCss } from './HtmlUtil';
import icons from '@teliaee/icons/sprite.svg';

import 'telia-front-react/polyfill';

const SsoThemeProvider: React.FC<{ isModule: boolean; brand: TBrand; children: any }> = ({ isModule, brand, children }) => {
  const { routeStore } = useStores();

  const getValidBrand = (brand = 'telia'): string => {
    const recognisedBrands = ['diil', 'telia', 'super'];
    const lowerBrand = brand.toLowerCase();
    return recognisedBrands.includes(lowerBrand) ? lowerBrand : 'telia';
  };

  if (!brand) {
    brand = getValidBrand((routeStore.getParameter('app') as string) ?? window.location.hostname.split('.')[1]) as TBrand;
  }

  React.useEffect(() => {
    if (isModule) {
      injectModuleSsoCss(['sso-clean-styles', `sso-prefixed-styles-${brand}`, 'sso-prefixed-custom-styles']);
    } else {
      injectSsoCss([`sso-styles-${brand}`, 'sso-custom-styles']);
    }
  }, []);

  const getIconPath = (name: string) => {
    if (isModule) {
      return `/img/sso-icons.svg${name}`;
    }

    return icons + name;
  };

  return (
    <ThemeProvider
      brand={brand}
      theme={brand === 'super' ? 'dark' : undefined}
      getIconPath={getIconPath}
      root={isModule ? document.getElementById('sso-root') : undefined}
      portalRoot={isModule ? document.getElementById('sso-portal-root') : undefined}
    >
      {children}
    </ThemeProvider>
  );
};

export default SsoThemeProvider;
